if (document.getElementById('ee-tracking-page')) {

    // --- helpery bezpieczeństwa ---

    // Escapuje wartości wstawiane do innerHTML (ochrona przed XSS).
    function esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }

    // Dopuszcza tylko http(s) w linku trackingu (blokuje np. javascript:).
    function safeUrl(u) {
        try {
            const p = new URL(u);
            return (p.protocol === 'https:' || p.protocol === 'http:') ? p.href : '#';
        } catch {
            return '#';
        }
    }

    document
        .getElementById('orderTrackingForm')
        .addEventListener('submit', async function (e) {

            e.preventDefault();

            const orderNumber =
                document.getElementById('orderNumber').value.trim();

            const email =
                document.getElementById('orderEmail').value.trim();

            const resultBox =
                document.getElementById('tracking-result');

            resultBox.style.display = 'block';

            resultBox.innerHTML = `
                <div class="ee-result">
                    <div class="ee-result-title">
                        We zoeken naar je zending...
                    </div>
                </div>
            `;

            // Blokada przycisku na czas zapytania (brak podwójnych kliknięć)
            const submitBtn = e.currentTarget.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn ? submitBtn.textContent : '';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Bezig met zoeken…';
            }

            try {

                const response = await fetch(
                        'https://euroelectronics-tracker.patryk-sprus.workers.dev/track',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            orderNumber,
                            email,
                            store: "NL"
                        })
                    }
                );

const data = await response.json();

// Za dużo prób (rate limit) — osobny komunikat zamiast "niet gevonden"
if (response.status === 429 || data.status === 'RATE_LIMITED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Te veel pogingen
            </div>

            <div class="ee-error-message">
                Je hebt te vaak achter elkaar gezocht.
                Wacht een minuut en probeer het opnieuw.
            </div>

        </div>
    `;

    return;
}

if (data.status === 'CANCELLED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                De bestelling is geannuleerd
            </div>

            <div class="ee-error-message">
                Deze bestelling is geannuleerd en wordt niet verder verwerkt.
            </div>

        </div>
    `;

    return;
}

if (!data.success) {

if (data.status === 'NOT_SHIPPED') {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-pending">

                <div class="ee-result-title">
                    We bereiden je bestelling voor
                </div>

<div class="ee-info-message">


 <br>

    Je bestelling is ontvangen en wordt verwerkt.

    <br><br>

    Er is nog geen trackingnummer toegewezen.
    Zodra de zending is verzonden, is de trackinginformatie beschikbaar op deze pagina en in een e-mail.

    <br><br>

    Als je nog vragen hebt over je bestelling, neem dan contact op met onze klantenservice.

    <br>

                    <a href="https://nl.euroelectronics.eu/pages/contact-1" class="ee-contact-link">
                        Neem contact met ons op
                    </a>

                </div>

            </div>
        `;

    } else {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-error">

                <div class="ee-result-title">
                    Bestelling niet gevonden
                </div>

                <div class="ee-error-message">
                    Er kon geen bestelling worden gevonden met het opgegeven ordernummer en e-mailadres.

                    Controleer of de gegevens correct zijn ingevoerd en probeer het opnieuw.
                    <br><br>

                    Als je hulp nodig hebt, neem dan contact op met onze klantenservice.
                    <br>

                    <a href="https://nl.euroelectronics.eu/pages/contact-1" class="ee-contact-link">
                        Ga naar het contactformulier
                    </a>

                </div>

            </div>
        `;

    }

    return;
}
const productsHtml =
  (data.products || [])
    .map(product => `
 <div class="ee-product">

    <div class="ee-product-content">

        <div class="ee-product-title">
            ${esc(product.title)}
        </div>

    </div>

    <div class="ee-product-qty">
        ${esc(product.quantity)}x
    </div>

</div>
    `)
    .join('');

                resultBox.innerHTML = `
                    <div class="ee-result">

                        <div class="ee-result-title">
                            Zending gevonden
                        </div>
<div class="ee-result-description">
                            Hieronder vind je informatie over je zending.
                          
                            Klik op de knop hieronder om direct naar de tracking bij de vervoerder te gaan.
                           
                       </div>

                       

                        <div class="ee-result-grid">

                            <div>
                                <div class="ee-result-label">
                                    Ordernummer
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.orderNumber || orderNumber)}
                                </div>
                            </div>

                            <div>
                                <div class="ee-result-label">
                                    Trackingnummer
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.trackingNumber)}
                                </div>
                            </div>

                        </div>

                        <a
                            href="${safeUrl(data.trackingUrl)}"
                            target="_blank"
                            rel="noopener"
                            class="ee-track-btn"
                        >
                            Volg de zending
                        </a>

                    </div>

                    <div class="ee-products-section">

  <div class="ee-products-title">
       Bestelde producten (${data.products?.length || 0})
  </div>

  ${productsHtml}

</div>
                `;

                resultBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });

            } catch (err) {

                console.error(err);

                resultBox.innerHTML = `
                    <div class="ee-result ee-result-error">

                        <div class="ee-result-title">
                            Er is een fout opgetreden
                        </div>

                        <p>
                            Er kon geen verbinding worden gemaakt met het trackingsysteem.
                            Probeer het later opnieuw.
                        </p>

                    </div>
                `;

            } finally {

                // Odblokowanie przycisku niezależnie od wyniku
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }

            }

        });

}